export default {"src":"/_next/static/media/azure-icon.097af0ed.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};